import CompanyDumpsAdd from './CompanyDumpsAdd';

export default CompanyDumpsAdd;
